<template>
  <div>
    <div class="main-description-header-tags-wrap less">
    <span v-for="(e,i) in extra" :key="i" style="font-size: 15px;" class="main-description-header-tag">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13" width="17px" height="13px">
        <path fill="#6D9E11"
          fill-rule="nonzero"
          d="M5.281818 9.9977275L1.320455 6.0363638 0 7.3568184l5.281818 5.2818183L16.6 1.3204546 15.279546 0z">
        </path>
      </svg>

      <span v-text="e.name"></span>
    </span>
    </div>
    <transition-group name="fade">


      <div class="dealer-packs"  v-show="carPacks.length" v-for="(packs, i) in convertSecPacks"
           :key="packs.title">
        <div class="main-description-title">
          <transition name="toggle" mode="out-in" :duration="300">
            <span>{{ packs.title }}</span>
          </transition>
        </div>
        <DealerPack :icon="/*!packs.base*/true" :carPacks="packs.data"
                   :more="true"/>
      </div>
    </transition-group>
    <!-- <div v-if="carCompany" class="car-company"> -->

    <!--            <a-blank v-if="$store.state.isApp" class="btn btn-dealer"-->
    <!--                     @click.prevent="webSite()">-->
    <!--                <img src="/img/arrow.svg"/> Vefur söluaðila&#45;&#45;-->
    <!--            </a-blank>-->
    <!--            <a-blank v-else class="btn btn-dealer" :href="getWebSiteUrl">-->
    <!--                <img src="/img/arrow.svg"/> Vefur söluaðila-->
    <!--            </a-blank>-->
    <!-- <a-blank class="btn btn-dealer" :href="getWebSiteUrl">
        <img src="/img/arrow.svg"/> Vefur söluaðila
    </a-blank> -->
    <!-- </div> -->
  </div>
</template>


<script>
import DealerPack from "./DealerPack";
import getBaseUrl from "@/helpers/getBaseUrl";

export default {
  props: {
    carPacks: {
      type: [Object, Array]
    },
    carCompany: {
      type: [Object, Array]
    },
    car: {
      type: [Object, Array]
    }
  },
  components: {
    DealerPack
  },
  computed: {
    extra() {
      return this.car.package_extra;
    },
    convertSecPacks() {
      const filter = this.carPacks && this.carPacks.filter(pack => pack.data && pack.data.some(el => el.name));

      return filter.map(pack => ({
        data: pack.data,
        title: pack.extra_packages ?
            pack.title :
            (pack.title.toUpperCase() != 'STAÐALBÚNAÐUR' ? 'Búnaður í ' : '') + pack.title + (pack.ptitle ? ` umfram ${pack.ptitle}` : ''),
        base: pack.base
      })).reverse()
    },
    getWebSiteUrl() {
      return this.$store.state.viewSiteLink + this.car.id
    }
  }
};
</script>
